var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.25C5.12391 0.25 0.75 4.62391 0.75 10C0.75 15.3761 5.12391 19.75 10.5 19.75C15.8761 19.75 20.25 15.3761 20.25 10C20.25 4.62391 15.8761 0.25 10.5 0.25ZM15.5742 6.73234L9.27422 14.2323C9.20511 14.3147 9.11912 14.3812 9.02207 14.4273C8.92502 14.4735 8.81918 14.4983 8.71172 14.5H8.69906C8.59394 14.5 8.49 14.4778 8.39398 14.435C8.29797 14.3922 8.21202 14.3297 8.14172 14.2516L5.44172 11.2516C5.37315 11.1788 5.31981 11.0931 5.28483 10.9995C5.24986 10.9059 5.23395 10.8062 5.23805 10.7063C5.24215 10.6064 5.26617 10.5084 5.3087 10.4179C5.35124 10.3275 5.41142 10.2464 5.48572 10.1796C5.56002 10.1127 5.64694 10.0614 5.74136 10.0286C5.83579 9.99578 5.93581 9.98219 6.03556 9.98861C6.13531 9.99502 6.23277 10.0213 6.32222 10.0659C6.41166 10.1106 6.49128 10.1726 6.55641 10.2484L8.67938 12.6072L14.4258 5.76766C14.5547 5.61863 14.737 5.52631 14.9335 5.51066C15.1299 5.49501 15.3246 5.55728 15.4754 5.68402C15.6263 5.81075 15.7212 5.99176 15.7397 6.18793C15.7582 6.3841 15.6988 6.57966 15.5742 6.73234Z",
    fill: "#168404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.e62babf3ed3320b612cc489947cd80fb.svg";
export { ForwardRef as ReactComponent };